import { SessionProvider } from '@sdk/session/SessionContext';
import ToastComponent from '@sdk/common/toast/ToastComponent';

import { Router } from '@web/Router/Router';
import { Particles } from '@web/components/Particles/Particles';
import { QueryClientProvider } from '@web/components/QueryClientProvider/QueryClientProvider';
import { SocketConnectionProvider } from '@web/components/SocketConnectionProvider/SocketConnectionProvider';
import {
  StatusServiceBridgeProvider,
  StatusService,
} from '@web/components/StatusServiceBridgeProvider/StatusServiceBridgeProvider';
import {
  PremiumGuardBridge,
  PremiumGuardAdapter,
} from '@web/components/PremiumGuardAdapter/PremiumGuardAdapter';

type Props = {
  premiumGuardBridge: PremiumGuardBridge;
  socketConnection: any;
  statusService: StatusService;
};
export const App = ({ premiumGuardBridge, socketConnection, statusService }: Props) => (
  <Particles>
    <QueryClientProvider>
      <SessionProvider>
        <StatusServiceBridgeProvider statusService={statusService}>
          <SocketConnectionProvider connection={socketConnection}>
            <PremiumGuardAdapter premiumGuardBridge={premiumGuardBridge}>
              <Router />
              <ToastComponent />
            </PremiumGuardAdapter>
          </SocketConnectionProvider>
        </StatusServiceBridgeProvider>
      </SessionProvider>
    </QueryClientProvider>
  </Particles>
);
